import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import NotFound from "@/pages/NotFound";

const Home = lazy(() => import("@/pages/home/page"));
const BusinessMeeting = lazy(() => import("@/pages/business-meeting/page"));
const OfflineTranslation = lazy(() => import("@/pages/offline-translation/page"));
const BusinessTravel = lazy(() => import("@/pages/business-travel/page"));
const Privacy = lazy(() => import("@/pages/privacy/page"));
const HowItWorks = lazy(() => import("@/pages/how-it-works/page"));
const Pricing = lazy(() => import("@/pages/pricing/page"));
const Blog = lazy(() => import("@/pages/blog/page"));
const BlogArticle = lazy(() => import("@/pages/blog/article/page"));
const BlogCategory = lazy(() => import("@/pages/blog/category/page"));
const Support = lazy(() => import("@/pages/support/page"));
const About = lazy(() => import("@/pages/about/page"));
const PrivacyPolicy = lazy(() => import("@/pages/privacy-policy/page"));
const Terms = lazy(() => import("@/pages/terms/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "business-meeting", element: <BusinessMeeting /> },
      { path: "offline-translation", element: <OfflineTranslation /> },
      { path: "business-travel", element: <BusinessTravel /> },
      { path: "privacy", element: <Privacy /> },
      { path: "how-it-works", element: <HowItWorks /> },
      { path: "pricing", element: <Pricing /> },
      { path: "blog", element: <Blog /> },
      { path: "blog/category/:categorySlug", element: <BlogCategory /> },
      { path: "blog/:slug", element: <BlogArticle /> },
      { path: "support", element: <Support /> },
      { path: "about", element: <About /> },
      { path: "privacy-policy", element: <PrivacyPolicy /> },
      { path: "terms", element: <Terms /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;